module.exports = __webpack_public_path__ + "static/media/icon_arrow_right.accf2e83.svg";